import { MutationTree } from 'vuex';
import { State } from './state';
import { Umfuhr, Umfuhrpos } from '@/modules/ewwms/models/Lager/UmfuhrModels';

export enum MutationTypes {
  SetUmfuhr = 'SETUMFUHR',
  AddUmfuhr = 'ADDUMFUHR',
  UpdateUmfuhr = 'UPDATEUMFUHR',
  DeleteUmfuhr = 'DELETEUMFUHR',

  SetUmfuhrPos = 'SETUMFUHRPOS',
  AddUmfuhrPos = 'ADDUMFUHRPOS',
  AddUmfuhrPosRange = 'ADDUMFUHRPOSRANGE',
  UpdateUmfuhrPos = 'UPDATEUMFUHRPOS',
  DeleteUmfuhrPos = 'DELETEUMFUHRDPOS',
}

export type Mutations = {
  [MutationTypes.SetUmfuhr](state: State, data: Array<Umfuhr>): void;
  [MutationTypes.AddUmfuhr](state: State, data: Umfuhr): void;
  [MutationTypes.UpdateUmfuhr](state: State, data: Umfuhr): void;
  [MutationTypes.DeleteUmfuhr](state: State, id: number): void;

  [MutationTypes.SetUmfuhrPos](state: State, data: Array<Umfuhrpos>): void;
  [MutationTypes.AddUmfuhrPos](state: State, data: Umfuhrpos): void;
  [MutationTypes.AddUmfuhrPosRange](state: State, data: Array<Umfuhrpos>): void;
  [MutationTypes.UpdateUmfuhrPos](state: State, data: Umfuhrpos): void;
  [MutationTypes.DeleteUmfuhrPos](state: State, id: number): void;
};

export const mutations: MutationTree<State> & Mutations = {
  //#region Auftrag
  [MutationTypes.SetUmfuhr](state: State, data: Array<Umfuhr>) {
    state.umfuhren = data;
    sessionStorage.setItem('umfuhren', JSON.stringify(state.umfuhren));
  },

  [MutationTypes.AddUmfuhr](state: State, data: Umfuhr) {
    state.umfuhren.push(data);
    sessionStorage.setItem('umfuhren', JSON.stringify(state.umfuhren));
  },

  [MutationTypes.UpdateUmfuhr](state: State, data: Umfuhr) {
    const olddata = state.umfuhren.find((a) => a.id === data.id);
    if (olddata != null) {
      const index = state.umfuhren.indexOf(olddata);
      state.umfuhren.splice(index, 1, data);
    }

    sessionStorage.setItem('umfuhren', JSON.stringify(state.umfuhren));
  },

  [MutationTypes.DeleteUmfuhr](state: State, id: number) {
    const olddata = state.umfuhren.find((a) => a.id === id);
    if (olddata != null) {
      const index = state.umfuhren.indexOf(olddata);
      state.umfuhren.splice(index, 1);
    }

    sessionStorage.setItem('umfuhren', JSON.stringify(state.umfuhren));
  },
  //#endregion

  //#region AuftragPos
  [MutationTypes.SetUmfuhrPos](state: State, data: Array<Umfuhrpos>) {
    state.umfuhrpos = data;
    sessionStorage.setItem('umfuhrpos', JSON.stringify(state.umfuhrpos));
  },

  [MutationTypes.AddUmfuhrPos](state: State, data: Umfuhrpos) {
    state.umfuhrpos.push(data);
    sessionStorage.setItem('umfuhrpos', JSON.stringify(state.umfuhrpos));
  },

  [MutationTypes.AddUmfuhrPosRange](state: State, data: Array<Umfuhrpos>) {
    state.umfuhrpos.push(...data);
    sessionStorage.setItem('umfuhrpos', JSON.stringify(state.umfuhrpos));
  },

  [MutationTypes.UpdateUmfuhrPos](state: State, data: Umfuhrpos) {
    const olddata = state.umfuhrpos.find((a) => a.id === data.id);
    if (olddata != null) {
      const index = state.umfuhrpos.indexOf(olddata);
      state.umfuhrpos.splice(index, 1, data);
    }

    sessionStorage.setItem('umfuhrpos', JSON.stringify(state.umfuhrpos));
  },

  [MutationTypes.DeleteUmfuhrPos](state: State, id: number) {
    const olddata = state.umfuhrpos.find((a) => a.id === id);
    if (olddata != null) {
      const index = state.umfuhrpos.indexOf(olddata);
      state.umfuhrpos.splice(index, 1);
    }

    sessionStorage.setItem('umfuhrpos', JSON.stringify(state.umfuhrpos));
  },
  //#endregion
};
